import { Level } from "../../../types";

const styles: Record<Level, string> = {
  debug: "bg-neutral-100 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300",
  info: "bg-sky-100 text-sky-800 dark:bg-sky-900/50 dark:text-sky-200",
  warning: "bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200",
  error: "bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-200",
  fatal: "bg-red-700 text-white dark:bg-red-600",
};

export const LevelBadge = ({ level }: { level: Level }) => (
  <span className={`inline-block rounded px-1.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${styles[level] ?? styles.info}`}>
    {level}
  </span>
);
